import { useCallback, useEffect } from "react";

type UseOutsideClickParams = {
  callbackFn: (node: Node) => void;
  addEvents: boolean;
  preventBlur?: boolean;
};

export function useOutsideClick({ callbackFn, addEvents, preventBlur }: UseOutsideClickParams): void {
  const handleOutsideClick = useCallback(
    (e: MouseEvent) => {
      preventBlur && e.preventDefault();
      callbackFn(e.target as Node);
    },
    [callbackFn, preventBlur],
  );

  useEffect(() => {
    if (addEvents) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [addEvents, handleOutsideClick]);
}
